module.exports = __webpack_public_path__ + "static/yhsg-21245edfef138a9169a82e3868626e4b.jpg";